import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import {
  LegalTextGoogle,
  LegalTextGoogleWithExample,
} from 'components/Stage/LegalTextGoogle';

/**
 * This component is a placeholder for the LegalText component to be able to link it via Contentful.
 */
export function LegalTextGoogleTopLink({
  showLegalExample,
}: {
  showLegalExample?: boolean;
}) {
  return (
    <Box sx={{ display: { xs: 'none', md: 'block' } }}>
      <Container maxWidth="lg">
        {showLegalExample ? (
          <LegalTextGoogleWithExample />
        ) : (
          <LegalTextGoogle />
        )}
      </Container>
    </Box>
  );
}
